import { storyblokEditable, StoryblokComponent } from "@storyblok/react";
import { useEffect } from "react";
import { useState } from "react";

const ProductSliderWrap = ({ blok }) => {
  //ImageSlider

  const [arrowRightVisibility, setVisibilityArrwoRight] = useState("unset");
  const [arrowLeftVisibility, setVisibilityArrwoLeft] = useState("unset");
  const [translateXPosition, setTranslateXPosition] = useState(0);
  const [currentPosition, setCurrentPosition] = useState(0);
  const [transition, setTransition] = useState("unset");

  let calculatedLength = blok.product.length - 4;
  let calculatedLengthTwo = blok.product.length -2;

  function hideLeftArrow(){
    if(currentPosition < 1){
      setVisibilityArrwoLeft("hidden");
    }else if(currentPosition >= 1){
      setVisibilityArrwoLeft("unset");
    }
  }

  function hideRightArrow(){
    if(window.innerWidth > 1250){
      if(currentPosition >= calculatedLength / 2){
        setVisibilityArrwoRight("hidden");
      }else if(currentPosition < calculatedLength / 2){
        setVisibilityArrwoRight("unset");
      }
    }

    if(window.innerWidth <= 1250){
      if(currentPosition >= calculatedLengthTwo / 2){
        setVisibilityArrwoRight("hidden");
      }else if(currentPosition < calculatedLengthTwo / 2){
        setVisibilityArrwoRight("unset");
      }
    }

    if(window.innerWidth <= 950){
      if(currentPosition >= blok.product.length -1){
        setVisibilityArrwoRight("hidden");
      }else if(currentPosition < blok.product.length -1){
        setVisibilityArrwoRight("unset");
      }
    }
  }

  useEffect(() => {
    hideLeftArrow();
    hideRightArrow();
  }, [currentPosition])

  function slideRight() {
    const products = document.getElementById("products");

    if (
      currentPosition >= 0 &&
      currentPosition < calculatedLength / 2 &&
      window.innerWidth > 1250
    ) {
      setCurrentPosition(currentPosition + 1);
      setTranslateXPosition(translateXPosition - 50);
      setTransition("0.5s ease-in-out");
    } else if (
      currentPosition >= 0 &&
      currentPosition < calculatedLengthTwo - 1 &&
      window.innerWidth <= 1250
    ) {
      setCurrentPosition(currentPosition + 1);
      setTranslateXPosition(translateXPosition - 100);
      setTransition("0.5s ease-in-out");

    } else if (
      currentPosition >= 0 &&
      currentPosition < blok.product.length - 1 &&
      window.innerWidth <= 950
    ) {
      setCurrentPosition(currentPosition + 1);
      setTranslateXPosition(translateXPosition - 100);
      setTransition("0.5s ease-in-out");

    }
  }

  function slideLeft() {
    const products = document.getElementById("products");

    if (currentPosition >= 1 && window.innerWidth > 1250) {
      setTranslateXPosition(translateXPosition + 50);
      setTransition("0.5s ease-in-out");
      setCurrentPosition(currentPosition - 1);
    } else if (
      currentPosition >= 1 &&
      currentPosition < blok.product.length - 1 &&
      window.innerWidth <= 1250
    ) {
      setCurrentPosition(currentPosition - 1);
      setTranslateXPosition(translateXPosition + 100);
      setTransition("0.5s ease-in-out");
    } else if (
      currentPosition >= 1 &&
      currentPosition < blok.product.length &&
      window.innerWidth <= 950
    ) {
      setCurrentPosition(currentPosition - 1);
      setTranslateXPosition(translateXPosition + 100);
      setTransition("0.5s ease-in-out");
    }
  }

  return (
    <div className="wrap">
    <div className="productslider-wrap inner-wrap flex" {...storyblokEditable(blok)}>
      <div className="productslider-wrap">
        <div className="productslider-content-outer">
          <div style={{ visibility: `${arrowLeftVisibility}` }} className="arrow-box-left">
            <img
              onClick={slideLeft}
              className="arrow-left"
              src="/src/arrow-left-grey-89-48.png"
              alt=""
            />
          </div>
          <div className="productslider-content flex flex-col">
            <h2 className="productslider-headline merriweather text-xl pb-6">
              {blok.brand_headline}
            </h2>
            <div>
              <div
                 style={{
                  transform: `translateX(${translateXPosition}%)`,
                  transition: transition
                }}
                id="products"
                className="productslider-product flex"
              >
                {blok.product.map((nestedBlok) => (
                  <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
                ))}
              </div>
              <h2 className="productslider-borderbottom merriweather text-xl pb-6"></h2>
            </div>
          </div>
          <div style={{ visibility: `${arrowRightVisibility}` }}  className="arrow-box-right">
            <img
              onClick={slideRight}
              className="arrow-right"
              src="/src/arrow-right-grey-25-48.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default ProductSliderWrap;
